import React, { useContext, useState, useEffect, useRef } from "react";
import { ThemeContext } from 'styled-components'
import styled from "styled-components";
import _ from "lodash";
import { withRouter } from "react-router-dom";
import { AuthContext } from "../../../../../auth-context";
import { DashboardContext } from '../../../dashboard-context'
import { useChatContext } from "stream-chat-react";
import { loadProfile, bulkEditCheckinDay, getOrCreatePortalChannel, batchSetVacationMode, setCoachingActualEndDate } from "../../../../../api";
import config from "../../../../../config"
import RefreshIcon from "../../../../../images/refresh.png";
import Icon from '@material-ui/core/Icon';
import { ReactComponent as VacationIcon } from "../../../../../images/vacation-icon.svg";
import { ReactComponent as VacationIconLight } from "../../../../../images/vacation-icon-light.svg";
import { ReactComponent as ArrowLeft } from "../../../../../images/arrow-left.svg";
import { ReactComponent as ArrowRight } from "../../../../../images/arrow-right.svg";
import { ReactComponent as ArrowUp} from "../../../../../images/arrow-up.svg";
import { ReactComponent as ArrowDown } from "../../../../../images/arrow-down.svg";
import { ReactComponent as ToggleLeft } from "../../../../../images/toggle-left.svg";
import { ReactComponent as ToggleRight } from "../../../../../images/toggle-right.svg";
import { ReactComponent as PauseIcon } from "../../../../../images/new-vacation-mode/icon-small-pause.svg";
import { todayString, getDaysSinceWeighIn, hostDateToString, dateStringAddDays } from "../../inspect/util";
import Slider from "react-slick";
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';
import MacroGraph from '../../inspect/components/average-graph/macro-graph'
import { Line } from 'rc-progress'
import { Row, Action } from '../../../../../components/action-button'
import SearchIcon from '@material-ui/icons/Search';
import EditIcon from '@material-ui/icons/Edit';
import Checkbox from "@material-ui/core/Checkbox";
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import AssignmentCheckIcon from '@material-ui/icons/AssignmentTurnedIn';
import AssignmentIcon from '@material-ui/icons/Assignment';
import { BulkEditCheckin } from "./bulk-edit-check-in-date";
import { BulkEditVacation } from "./bulk-edit-vacation";
import { hasCoachingPlanAccess } from '../../../../../feature-access'
import { getAttentionSettings } from "./alert-table-settings";
import { MISSED_TRACKING_LABELS } from "./missed-tracking-labels";
import { SurveyModal } from "../../surveys/components/survey-modal";
import moment from "moment";
import CoachingEndDateModal from "./coaching-end-date-modal";

const WhiteCheckbox = withStyles({
})((props) => <Checkbox color="default" {...props} />);

const CustomDarkTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#08091f',
    color: '#FFFFFF',
    borderRadius: '12px',
    boxShadow: theme.shadows[1],
    fontFamily: 'DM Sans',
    fontSize: 12,
  },
  arrow: {
    color: '#08091f'
  }
}))(Tooltip);

const DarkTooltip = ({children, title, placement}) => (
  <CustomDarkTooltip
    arrow
    enterDelay={1300}
    title={title}
    placement={placement}
  >
    {children}
  </CustomDarkTooltip>
)

const ThisPeriodAverageTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#08091f',
    color: '#FFFFFF',
    borderRadius: '12px',
    boxShadow: theme.shadows[1],
    fontFamily: 'DM Sans',
    fontSize: 12,
    maxWidth: '600px'
  },
  arrow: {
    color: '#08091f'
  }
}))(Tooltip);

const TipContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 6px;
  p {
    font-size: .9rem;
    font-weight: normal;
    display: flex;
    align-items: center;
    margin-bottom: 4px;
  }
  li {
    font-size: .9rem;
    font-weight: normal;
    margin-bottom: 4px;
    span {
      font-weight: bold;
    }
  }
  span {
    font-size: .9rem;
    font-weight: normal;
    text-align: center;
    margin-bottom: 4px;
  }
`;

const CaloriesSummary = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin: 8px auto 16px;
  width: 120px;

  label {
    color: #ffffffc7;
    font-family: 'DM Sans', sans-serif;
    font-size: 0.875rem;
    font-weight: bold;
    margin: 4px 0;
    white-space: nowrap;
  }
`;

const Container = styled.div`
  margin: 0 auto;
  max-width: 1600px;
  width: 100%;
`;

const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  @media(max-width: 1100px) {
    flex-direction: column;
  }
`;

const Legend = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 8px;

  @media(max-width: 1100px) {
    flex-direction: column;
    align-items: flex-start;
    flex-wrap: wrap;
  }

  span {
    font-weight: 600;
    margin-right: 24px;
  }
`;

const LegendKeys = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  > div {
    display: flex;
    align-items: center;
    margin: 0px 12px 0px 0px;

    p {
      font-size: 0.8rem;
      font-weight: 500;
      margin-left: 4px;
      white-space: nowrap;
    }
  }
`;

const TableTitle = styled.h2`
  padding-bottom: 8px;
  color: #181818;
  font-family: "DM Sans", sans-serif;
  font-size: 1.25rem;
  font-weight: 600;
`;

const TableContainer = styled.div`
  background: #fff;
  border-radius: 8px;
  box-shadow: 0px 0px 8px 0px #e1e2e6;
  max-height: 620px;
  margin: 0 auto;
  overflow: auto;
  position: relative;
  @media(max-width: 500px) {
    max-height: 380px;
  }
`;

const Table = styled.table`
  background: #fff;
  border-spacing: 0px;
  width: 100%;

  td, th {
    font-size: .9rem;
  }
`;

const TableHead = styled.thead`
  color: #fff;
`;

const TableBody = styled.tbody``;

const TableHeadRow = styled.tr``;

function getAccountCoachingPlan(account) {
  if (!account || !account.coaching_plan) {
    return null
  }

  if (typeof account.coaching_plan === "string") {
    try {
      return JSON.parse(account.coaching_plan)
    } catch (err) {
      return null
    }
  }

  return account.coaching_plan
}

function hasActiveCoachingPlan(account) {
  const coachingPlan = getAccountCoachingPlan(account)
  const endDateValue = coachingPlan && (coachingPlan.actual_end_date || coachingPlan.end_date)
  if (!endDateValue) {
    return false
  }

  const endDate = moment.utc(endDateValue)
  return endDate.isValid() && endDate.isSameOrAfter(moment.utc(), "day")
}

function getCoachingPlanBarClass(account) {
  if (!hasActiveCoachingPlan(account)) {
    return ""
  }

  const coachingPlan = getAccountCoachingPlan(account)
  switch (coachingPlan && coachingPlan.plan_name) {
    case "PILOT NUTRITION 3 MONTHS":
    case "DISCOUNTED PILOT NUTRITION 3 MONTHS":
      return "coaching-plan-nutrition"
    case "PILOT NUTRITION + EXERCISE 3 MONTHS":
    case "DISCOUNTED PILOT NUTRITION + EXERCISE 3 MONTHS":
      return "coaching-plan-exercise"
    default:
      return ""
  }
}

function hasCoachingPlanInfo(coachingPlan) {
  return !!coachingPlan &&
    typeof coachingPlan === "object" &&
    Object.keys(coachingPlan).length > 0 &&
    !!(
      coachingPlan.plan_name ||
      coachingPlan.purchase_date ||
      coachingPlan.actual_end_date ||
      coachingPlan.end_date ||
      coachingPlan.price ||
      coachingPlan.transaction_id
    )
}

function needsActualEndDateAttention(actualEndDate) {
  if (!actualEndDate) {
    return true
  }

  const endDate = moment.utc(actualEndDate)
  return endDate.isValid() && endDate.diff(moment.utc(), "days") < 21
}

function getActualEndDateStatusText(actualEndDate) {
  if (!actualEndDate) {
    return "No end date"
  }

  const endDate = moment.utc(actualEndDate)
  if (!endDate.isValid()) {
    return null
  }

  const daysLeft = endDate.diff(moment.utc(), "days")
  if (daysLeft < 0) {
    return "Ended"
  }

  if (daysLeft === 0) {
    return "Ends today"
  }

  return `${daysLeft} ${daysLeft === 1 ? "day" : "days"} left`
}

const TableBodyRow = styled.tr`
  position: relative;

  &.coaching-plan-nutrition {
    background-image: linear-gradient(#00eb45,#0ea039);
    background-repeat: no-repeat;
    background-size: 6px 100%;
  }

  &.coaching-plan-exercise {
    background-image: linear-gradient(#FFC000,#FFC000);
    background-repeat: no-repeat;
    background-size: 6px 100%;
  }

  &:hover {
    background-color: #f2f2f2;
  }

  &.coaching-plan-nutrition:hover {
    background-color: #f2f2f2;
    background-image: linear-gradient(#00eb45,#0ea039);
    background-repeat: no-repeat;
    background-size: 6px 100%;
  }

  &.coaching-plan-exercise:hover {
    background-color: #f2f2f2;
    background-image: linear-gradient(#FFC000,#FFC000);
    background-repeat: no-repeat;
    background-size: 6px 100%;
  }
`;

const HeadCell = styled.th`
  background: #070c29 !important;
  font-family: ${(props) => props.theme.font.primary};
  font-weight: 400;
  /* min-width: ${(props) => (props.bigWidth ? "180px" : "100px")}; */
  padding: 4px 8px;
  position: sticky;
  text-align: left;
  top: 0;
  white-space: nowrap;
  z-index: 30;
`;

const DataCell = styled.td`
  border-bottom: 1px solid #e8e8e8;
  color: ${(props) => (props.color ? props.color : "unset")};
  font-family: ${(props) =>
    props.number ? props.theme.font.primary : props.theme.font.secondary};
  font-weight: ${(props) => (props.bold ? 600 : 400)};
  padding: 4px 8px;
  text-align: left;
  white-space: nowrap;
`;

const NameCell = styled.td`
  border-bottom: 1px solid #e8e8e8;
  color: ${(props) => (props.nearPeriod ? "#FFF" : "unset")};
  font-family: ${(props) => props.theme.font.secondary};
  font-weight: 400;
  padding: 4px 8px;
  text-align: left;
  max-width: 120px;
  position: relative;
  white-space: nowrap;

  img {
    margin-right: 2px;
  }
  span {
    background: ${(props) => (props.nearPeriod ? "#e129a3" : "none")};
    border-radius: 100px;
    padding: ${(props) => (props.nearPeriod ? "4px 10px" : "none")};
    max-width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

const NameCellContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  min-height: 32px;
  overflow: hidden;
`;

const NameText = styled.p`
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

const CoachingAttentionText = styled.button`
  align-items: center;
  background: transparent;
  border: none;
  color: #dc544a;
  cursor: pointer;
  display: flex;
  font-family: ${(props) => props.theme.font.primary};
  font-size: 0.7rem;
  font-weight: 700;
  left: 8px;
  line-height: 1;
  margin: 0;
  padding: 0;
  position: absolute;
  top: 2px;

  svg {
    fill: #dc544a;
    height: 12px;
    margin-left: 3px;
    width: 12px;
  }
`;

const LastCheckinCell = styled.td`
  border-bottom: 1px solid #e8e8e8;
  color: ${(props) => {
    if (props.tracking) {
      if (props.tracking === "Incomplete") {
        return "#dc544a"
      } else if (props.tracking === "Complete") {
        return "#4cb050"
      } else {
        return "#f4b300"
      }
    } else {
      return "unset"
    }
    }};
  font-family: ${(props) =>
    props.number ? props.theme.font.primary : props.theme.font.secondary};
  font-weight: ${(props) => (props.bold ? 600 : 400)};
  padding: 4px 8px;
  position: relative;
  padding-top: 6px;
  white-space: nowrap;
  text-align: left;
`;

const LastCheckinPill = styled.div`
  background: #dadada;
  border-radius: 100px;
  color: #848484;
  display: inline-block;
  padding: 2px 12px;
`;

const LastCheckinContainer = styled.div`
  display: flex;
  align-items: center;
  position: relative;

  span {
    text-transform: capitalize;
    margin-left: 4px;
  }

  p {
    margin-left: 4px;
  }
`;

const Dot = styled.div`
  background: ${(props) => (props.color ? props.color : "unset")};
  border: ${(props) =>
    props.borderColor
      ? props.borderColor
      : props.color
      ? "1px solid transparent;"
      : "1px solid #181818;"};
  border-radius: 100px;
  flex-shrink: 0;
  height: 10px;
  width: 10px;
  margin: 0 1px;
`;

const SmallMacroCircle = styled.div`
  background: ${(props) => (props.color)};
  border-radius: 50%;
  color: white;
  flex-shrink: 0;
  height: 20px;
  width: 20px;
  margin: 0 3px;
  text-align: center;
  padding: 1px 0 0 0;
`;

const Bar = styled.div`
  background: #f0f0f0;
  border-radius: 100px;
  display: flex;
  align-items: flex-end;
  flex-shrink: 0;
  height: 25px;
  width: 10px;
  margin: 0 4px 0px 0px;

  >div {
    background: ${(props) => (props.color ? props.color : "unset")};
    border-radius: 100px;
    content: "";
    width: 10px;
    height: ${(props) => (props.height ? `${props.height}%` : "unset")};
  }
`;

const MenstrualKey = styled.div`
  background: #e129a3;
  border-radius: 100px;
  flex-shrink: 0;
  height: 10px;
  width: 30px;
  margin: 0 1px;
`;

const ThisPeriodContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;

  button {
    background: none;
    cursor: pointer;
    border: none;
    width: 6px;
    height: 12px;

    svg {
      width: 6px;
      height: 12px;
    }
  }
`;

const ArrowsGroup = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const ImprovingText = styled.span`
  font-size: .6rem;
  text-transform: none !important;
  position: absolute;
  bottom: -13px;
  left: 50%;
  transform: translateX(-50%);
  margin: 0;
`;

const PermissionText = styled.p`
  color: #898989;
  font-size: .9rem !important;
  position: absolute;
  text-size-adjust: none;
  left: 50%;
  transform: translateX(-50%);
  @media(max-width: 1200px) {
    left: 150px;
    transform: none;
  }
`;

const BulkEdit = styled.button`
  background: ${(props) => props.highlight ? props.theme.color.primary : props.theme.color.dark};
  border: none;
  border-radius: 100px;
  color: #FFF;
  cursor: pointer;
  padding: 6px 12px;
  margin-left: 8px;
  transition: 0.3s ease all;
`;

const ShowGroupFilter = styled.button`
  background: ${(props) => props.highlight ? props.theme.color.primary : props.theme.color.dark};
  border: none;
  border-radius: 100px;
  color: #FFF;
  cursor: pointer;
  padding: 6px 12px;
  margin-left: 8px;
  transition: 0.3s ease all;
`;

const BulkAction = styled.button`
  background: ${(props) => props.theme.color.dark};
  border: none;
  border-radius: 100px;
  color: #FFF;
  cursor: pointer;
  padding: 6px 12px;
  margin-left: 8px;
`;

const VacationText = styled.span`
  background: #06010d;
  border-radius: 30px;
  display: block;
  padding: 0px 4px;
  font-size: 0.7rem;
  font-weight: 600;
  margin: 0 0 0 28px;
  width: 80px;
  text-align: center;
  color: ${props => props.color || "#32F6DB"};
`;

const LastCheckinDate = styled.p`
  font-size: 0.7rem;
  font-weight: 500;
  color: #333333;
  margin: 0;
  position: absolute;
  top: 2px;
  left: 32px;
`;

const MICRONUTRIENT_LABELS = {
  'iron':        'Iron',
  'potassium':   'Potassium',
  'sodium':      'Sodium',
  'vitamin_a':   'Vitamin A',
  'vitamin_d':   'Vitamin D',
  'vitamin_e':   'Vitamin E',
  'vitamin_c':   'Vitamin C',
  'vitamin_b1':  'Thiamine',
  'vitamin_b2':  'Riboflavin',
  'vitamin_b3':  'Niacin',
  'vitamin_b5':  'Pantothenic acid',
  'vitamin_b6':  'Vitamin B6',
  'vitamin_b12': 'Vitamin B12',
  'vitamin_b9':  'Folate'
};

const ThisPeriodCellIndividual = ({data}) => {
  const { days, report_date } = data;
  const sliderRef = useRef();
  const [slide, setSlide] = useState(1);

  const handleClick = (val) => {
    sliderRef.current.slickGoTo(val);
    setSlide(val);
  }

  const daysSinceCheckin = getDaysSinceWeighIn(report_date);
  let last14Max = days;
  let dotArray = [];
  if (daysSinceCheckin > 14) {
    last14Max = _.takeRight(days, 14);
  } else {
    last14Max = days.slice(0, daysSinceCheckin + 1);
  }

  for (let i = 0; i < last14Max.length; i++) {
    if (last14Max[i] === "n") {
      dotArray.push(
        <DarkTooltip
          arrow
          title={
            <TipContent>
              <p style={{display: 'flex', alignItems: 'center'}}><Dot borderColor="1px solid #FFF" style={{marginRight: '8px'}} /> No food was logged</p>
            </TipContent> 
          }
          key={i}
        >
          <Dot key={i} />
        </DarkTooltip>
      );
    } else if (last14Max[i] === "o") {
      dotArray.push(
        <DarkTooltip
          arrow
          title={
            <TipContent>
              <p style={{display: 'flex', alignItems: 'center'}}><Dot color="#f4b300" style={{marginRight: '8px'}} /> Food was logged but macros were missed</p>
            </TipContent>
          }
          key={i}
        >
          <Dot key={i} color="#f4b300" />
        </DarkTooltip>
      );
    } else if (last14Max[i] === "i") {
      dotArray.push(
        <DarkTooltip
          arrow
          title={
            <TipContent>
              <p style={{display: 'flex', alignItems: 'center'}}><Dot color="#4cb050" style={{marginRight: '8px'}} /> Food was logged and macros were hit</p>
            </TipContent>
          }
          key={i}
        >
          <Dot key={i} color="#4cb050" />
        </DarkTooltip>
      );
    } else if (last14Max[i] === "v" && !data.vacation_mode_info?.practice_mode) {
      // Backend only sends "v" for pause your goal mode, practice mode needs n/i/o as usual
      dotArray.push(
        <DarkTooltip
          arrow
          title={
            <TipContent>
              <p style={{display: 'flex', alignItems: 'center'}}><PauseIcon style={{width: '10px', marginRight: '8px'}} /> Goal was paused </p>
            </TipContent>
          }
          key={i}
        >
          <PauseIcon key={i} style={{ margin: '0 1px'}}/>
        </DarkTooltip>
      );
    }
  }

  let slide0Array = dotArray.slice(0, 7);
  let slide1Array = dotArray.slice(7);

  const showLeftArrow = (slide === 1 && slide1Array.length !== 0)
  const showRightArrow = (slide === 0)

  const settings = {
    dots: false,
    speed: 200,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 2,
    arrows: false,
    initialSlide: 1,
  };

  return (
    <ThisPeriodContainer>
      <button onClick={() => handleClick(0)} style={{ cursor: showLeftArrow ? 'pointer' : 'unset', opacity: showLeftArrow ? 1 : 0}}><ArrowLeft /></button>
      <div style={{margin: '0px 8px', width: '84px'}}>
        <Slider ref={sliderRef} {...settings}>
          <div>
            <div style={{ display: "flex", alignItems: "center", justifyContent: 'flex-end', width: '84px', overflow: 'hidden' }}>
              {slide0Array}
            </div>
          </div>
          <div>
            <div style={{ display: "flex", alignItems: "center", justifyContent: 'flex-start', width: '84px', overflow: 'hidden' }}>
              {slide1Array.length === 0 ? slide0Array : slide1Array}
            </div>
          </div>
        </Slider>
      </div>
      <button onClick={() => handleClick(1)} style={{ cursor: showRightArrow ? 'pointer' : 'unset', opacity: showRightArrow ? 1 : 0}}><ArrowRight /></button>
    </ThisPeriodContainer>
  );
}

const ThisPeriodCellAverage = ({data}) => {
  const colorMap = {
    'under': '#31bfff',
    'in-range': '#00ee46',
    'over': '#ed28a5'
  }

  if (getDaysSinceWeighIn(data.report_date) === 0) {
    return (
      <i>no average yet</i>
    )
  }

  const avgProtein = Math.round(data.avgProtein)
  const avgCarbs = Math.round(data.avgCarbs)
  const avgFat = Math.round(data.avgFat)
  const avgTargetProtein = Math.round(data.avgTargetProtein)
  const avgTargetCarbs = Math.round(data.avgTargetCarbs)
  const avgTargetFat = Math.round(data.avgTargetFat)
  const avgCalories = Math.round(4 * (data.avgProtein + data.avgCarbs) + 9 * data.avgFat)
  const avgTargetCalories = 4 * (data.avgTargetProtein + data.avgTargetCarbs) + 9 * data.avgTargetFat
  const remainingAvgCarbs = Math.round(avgTargetCarbs - avgCarbs)
  const remainingAvgFat = Math.round(avgTargetFat - avgFat)
  const remainingAvgProtein = Math.round(avgTargetProtein - avgProtein)
  const proteinSlope = Math.round((1 / 30) * avgTargetProtein + 6.6666666667);
  const carbsSlope = Math.round((11 / 450) * avgTargetCarbs + 3.7777777778);
  const fatSlope = Math.round((2 / 75) * avgTargetFat + 10 / 3);
  let proteinStatus = "under";
  let carbsStatus = "under";
  let fatStatus = "under";

  if (avgTargetProtein > 0 && avgTargetProtein <= 100) {
    proteinStatus = remainingAvgProtein < -10 ? "over" : remainingAvgProtein >= -10 && remainingAvgProtein <= 10 ? "in-range" : "under";
  } else if (avgTargetProtein > 100 && avgTargetProtein < 250) {
    proteinStatus = remainingAvgProtein < -proteinSlope ? "over" : remainingAvgProtein >= -proteinSlope && remainingAvgProtein <= proteinSlope ? "in-range" : "under";
  } else {
    proteinStatus = remainingAvgProtein < -15 ? "over" : remainingAvgProtein >= -15 && remainingAvgProtein <= 15 ? "in-range" : "under";
  }

  if (avgTargetCarbs > 0 && avgTargetCarbs <= 50) {
    carbsStatus = remainingAvgCarbs < -5 ? "over" : remainingAvgCarbs >= -5 && remainingAvgCarbs <= 5 ? "in-range" : "under";
  } else if (avgTargetCarbs > 50 && avgTargetCarbs < 500) {
    carbsStatus = remainingAvgCarbs < -carbsSlope ? "over" : remainingAvgCarbs >= -carbsSlope && remainingAvgCarbs <= carbsSlope ? "in-range" : "under";
  } else {
    carbsStatus = remainingAvgCarbs < -16 ? "over" : remainingAvgCarbs >= -16 && remainingAvgCarbs <= 16 ? "in-range" : "under";
  }

  if (avgTargetFat > 0 && avgTargetFat <= 25) {
    fatStatus = remainingAvgFat < -4 ? "over" : remainingAvgFat >= -4 && remainingAvgFat <= 4 ? "in-range" : "under";
  } else if (avgTargetFat > 25 && avgTargetFat < 175) {
    fatStatus = remainingAvgFat < -fatSlope ? "over" : remainingAvgFat >= -fatSlope && remainingAvgFat <= fatSlope ? "in-range" : "under";
  } else {
    fatStatus = remainingAvgFat < -8 ? "over" : remainingAvgFat >= -8 && remainingAvgFat <= 8 ? "in-range" : "under";
  }


  return (
    <ThisPeriodAverageTooltip
      arrow
      title={
        <TipContent>
          <MacroGraph
            proteinConsumed={Math.round(avgProtein)}
            carbsConsumed={Math.round(avgCarbs)}
            fatConsumed={Math.round(avgFat)}
            proteinTarget={Math.round(avgTargetProtein)}
            carbsTarget={Math.round(avgTargetCarbs)}
            fatTarget={Math.round(avgTargetFat)}
            vacationMode={data.vacation_mode}
            name={data.full_name}
            showConsumedMacros
            showUnderRange
          />
          <CaloriesSummary>
            <label>AVG. CALORIES</label>
            <Line
              percent={avgTargetCalories > 0 ? (avgCalories / avgTargetCalories) * 100 : 0}
              strokeWidth="9"
              strokeLinecap="round"
              strokeColor="#31bfff"
              trailWidth="9"
              trailColor="#1d2345"
            />
            <label style={{ color: '#FFF' }}>{avgCalories} / {Math.round(avgTargetCalories)} EATEN</label>
          </CaloriesSummary>
          {!_.isEmpty(data.micronutrients_rda_portion) && data.tracked_calories && (
            <>
              <p>{Math.round(data.tracked_calories_with_micronutrients * 100 / data.tracked_calories)}% of the tracked calories in this period included micronutrient information.</p>
              <table>
                <thead>
                  <tr style={{textAlign: 'left', textDecoration: 'underline', fontSize: '16px'}}>
                    <th>Micronutrient</th>
                    <th>% RDA</th>
                  </tr>
                </thead>
                <tbody>
                  {Object.keys(MICRONUTRIENT_LABELS).map((m, n) => (
                    <tr key={n}>
                      <td>{MICRONUTRIENT_LABELS[m]}</td>
                      <td>{Math.round((m in data.micronutrients_rda_portion ? data.micronutrients_rda_portion[m] : 0) * 100 / data.days_since_check_in)}%</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </>
          )}
        </TipContent>
      }
    >
      <div style={{ display: "flex", alignItems: "center", justifyContent: 'flex-start', width: '84px', overflow: 'hidden' }}>
        <SmallMacroCircle color={colorMap[proteinStatus]}>P</SmallMacroCircle>
        <SmallMacroCircle color={colorMap[carbsStatus]}>C</SmallMacroCircle>
        <SmallMacroCircle color={colorMap[fatStatus]}>F</SmallMacroCircle>
      </div>
    </ThisPeriodAverageTooltip>
  );
}

const AccountsTable = (props) => {
  const { user, updateUser } = useContext(AuthContext);
  const canAccessCoachingPlans = hasCoachingPlanAccess(user.owner_id)
  const theme = useContext(ThemeContext)
  const { client, setActiveChannel } = useChatContext();
  const { filterGroupID, clientsTrainerID, setShowMessages, setMessageChannel, openSnackbar } = useContext(DashboardContext);
  const [sortType, setSortType] = useState({type: 'name', reverse: false});
  const [individualDaysForThisPeriod, setIndividualDaysForThisPeriod] = useState(1);
  const [createdStreamUsers, setCreatedStreamUsers] = useState([]);
  const [showSelect, setShowSelect] = useState(null);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [showBulkModal, setShowBulkModal] = useState(false);
  const [showVacationModal, setShowVacationModal] = useState(false);
  const [showSurveyModal, setShowSurveyModal] = useState(false)
  const [responseUserId, setResponseUserId] = useState(null)
  const [selectedCoachingAccount, setSelectedCoachingAccount] = useState(null)
  const [selectedCoachingDay, setSelectedCoachingDay] = useState(null)
  const [isCoachingEndDateLoading, setIsCoachingEndDateLoading] = useState(false)
  const attentionSettings = getAttentionSettings(user.attention_settings);

  useEffect(() => {
    if (!!user.messaging) {
      const searchResult = _.cloneDeep(user.accounts).filter(
        (entry) =>
          entry.claimed === 1 &&
          (user.role_id === 3 ? entry.trainers.includes(user.id) : true)
      );
      let userStreamIds = [];
      const createdStreamUsers = [];
      searchResult.forEach((entry) => {
        const userID = entry.user_id;
        const chatID = `${config.STREAMCHAT.userPrefix}${userID}`;
        userStreamIds.push(chatID);
      });
      userStreamIds = _.chunk(userStreamIds, 100);

      const fetchData = async () => {
        await Promise.all(
          userStreamIds.map(async (streamIds) => {
            return await client.queryUsers(
              { id: { $in: streamIds } },
              { last_active: -1 },
              { presence: false, limit: 100 }
            );
          })
        ).then((response) => {
          response.forEach((res) => {
            if (res.users.length > 0) {
              res.users.forEach((data) => {
                createdStreamUsers.push(data.id);
              });
            }
          });
        });

        setCreatedStreamUsers(createdStreamUsers);
      };

      fetchData();
    }
  }, [user.accounts]);
  
  useEffect(() => {
    const val = localStorage.getItem('individualDaysForThisPeriod')
    if (localStorage.getItem('individualDaysForThisPeriod')) {
      setIndividualDaysForThisPeriod(Number(val))
    }
  }, [])

  const toggleThisPeriod = (val) => {
    setIndividualDaysForThisPeriod(val)
    localStorage.setItem('individualDaysForThisPeriod', val)
  }

  const handleMessage = async (clientID, assignedTrainers) => {    
    const getId = await getOrCreatePortalChannel(user.id, clientID)
    const channelId = getId?.data?.result?.channel_id

    if(channelId) {
      const filter = { id: channelId };
      const sort = { last_message_at: -1 };
      const options = { watch: true, state: true }
      const getChannel = await client.queryChannels(filter, sort, options);
      setActiveChannel(getChannel[0]);
      setShowMessages(true);
      setMessageChannel(getChannel[0])
    }
  }

  const openCoachingEndDateModal = (account, coachingPlan) => {
    const endDate = coachingPlan.actual_end_date || coachingPlan.end_date
    const initialDate = endDate ? moment.utc(endDate).toDate() : new Date()
    setSelectedCoachingAccount(account)
    setSelectedCoachingDay(initialDate)
  }

  const closeCoachingEndDateModal = () => {
    if (isCoachingEndDateLoading) {
      return
    }

    setSelectedCoachingAccount(null)
    setSelectedCoachingDay(null)
  }

  const submitCoachingEndDate = () => {
    if (!selectedCoachingAccount || !selectedCoachingDay) {
      openSnackbar("Please select an end date.", true)
      return
    }

    setIsCoachingEndDateLoading(true)
    setCoachingActualEndDate(user.id, {
      account_id: selectedCoachingAccount.id,
      actual_end_date: moment(selectedCoachingDay).format("YYYY-MM-DD"),
    })
      .then(() => loadProfile(user.id))
      .then((res) => {
        updateUser(res.data.profile)
        openSnackbar("Coaching plan end date updated.", false)
        setIsCoachingEndDateLoading(false)
        setSelectedCoachingAccount(null)
        setSelectedCoachingDay(null)
      })
      .catch((err) => {
        const message = err.response && err.response.data && err.response.data.error
          ? err.response.data.error
          : "Unable to update coaching plan end date."
        openSnackbar(message, true)
        setIsCoachingEndDateLoading(false)
      })
  }

  const getGoalLevel = (
    goal,
    goal_weight_delta,
    targetWeight,
    useMetric,
    goal_min_weekly_calorie_increase
  ) => {
    if (goal === "MAINTENANCE") {
      if (useMetric === 1) {
        return (
          (targetWeight - goal_weight_delta).toFixed(1) +
          " - " +
          (targetWeight + goal_weight_delta).toFixed(1) +
          " kg"
        );
      } else {
        return (
          ((targetWeight - goal_weight_delta) * 2.204622).toFixed(1) +
          " - " +
          ((targetWeight + goal_weight_delta) * 2.204622).toFixed(1) +
          " lbs"
        );
      }
    } else if (goal === "REVERSE DIETING") {
      if (goal_min_weekly_calorie_increase) {
        return (
          goal_min_weekly_calorie_increase +
          " - " +
          (goal_min_weekly_calorie_increase + 15) +
          " Calories"
        );
      } else {
        return;
      }
    } else if (useMetric === 1) {
      return goal_weight_delta.toFixed(2) + " kg";
    } else {
      return (goal_weight_delta * 2.204622).toFixed(2) + " lbs";
    }
  };

  const renderTrackingData = (trackingStatus) => {
    let colorMap = {};
    colorMap[MISSED_TRACKING_LABELS[attentionSettings.missedtracking][0][0]] = "#f4b300";
    colorMap[MISSED_TRACKING_LABELS[attentionSettings.missedtracking][1][0]] = "#4cb050";
    colorMap[MISSED_TRACKING_LABELS[attentionSettings.missedtracking][2][0]] = "#dc544a";
    colorMap[MISSED_TRACKING_LABELS[attentionSettings.missedtracking][3][0]] = "#1cb09c";

    let toolTextMap = {};
    toolTextMap[MISSED_TRACKING_LABELS[attentionSettings.missedtracking][0][0]] = MISSED_TRACKING_LABELS[attentionSettings.missedtracking][0][1];
    toolTextMap[MISSED_TRACKING_LABELS[attentionSettings.missedtracking][1][0]] = MISSED_TRACKING_LABELS[attentionSettings.missedtracking][1][1];
    toolTextMap[MISSED_TRACKING_LABELS[attentionSettings.missedtracking][2][0]] = MISSED_TRACKING_LABELS[attentionSettings.missedtracking][2][1];
    toolTextMap[MISSED_TRACKING_LABELS[attentionSettings.missedtracking][3][0]] = MISSED_TRACKING_LABELS[attentionSettings.missedtracking][3][1];
    
    return (
      <DarkTooltip
        arrow
        title={
          <TipContent>
            <span style={{fontSize: '0.9rem', fontWeight: 'bold', textAlign: 'center', color: colorMap[trackingStatus]}}>{trackingStatus}</span>
            <p>{toolTextMap[trackingStatus]}</p>
          </TipContent>
        }
      >
        <DataCell bold color={colorMap[trackingStatus]}>
          {trackingStatus}
        </DataCell>
      </DarkTooltip>

    )
  };

  const renderGoalData = (data) => {
    const isPaused = data.vacation_mode > 0 && !data.vacation_mode_info.practice_mode
    const isPractice = data.vacation_mode > 0 && data.vacation_mode_info?.practice_mode

    let vacationText;
    if (isPaused) {
      vacationText = <VacationText color="#32F6DB">PAUSED</VacationText>
    } else if (isPractice) {
      vacationText = <VacationText color="#CFE92A">PRACTICE</VacationText>
    }

    if (data.goal === "REVERSE DIETING") {
      return (
        <DarkTooltip
          arrow
          title={
            <TipContent>
              <p>This is the client’s set goal</p>
            </TipContent>
          }
        >
          <DataCell>
            {vacationText}
            {theme.goal["REVERSE DIETING"]}
          </DataCell>
        </DarkTooltip>
      )
    } else {
      return (
        <DarkTooltip
          arrow
          title={
            <TipContent>
              <p>This is the client’s set goal</p>
            </TipContent>
          }
        >
          <DataCell>
            {vacationText}
            {theme.goal[data.goal]}: {data.goal !== "REVERSE DIETING" && getGoalLevel(
              data.goal,
              data.goal_weight_delta,
              data.target_weight,
              data.use_metric_units,
              data.goal_min_weekly_calorie_increase
            )}
          </DataCell>
        </DarkTooltip>
      )
    }
  };

  const renderLastCheckinData = (data) => {
    const formatWeightChange = (weight, previousWeight) => {
      if (weight == null || previousWeight == null) return null;
      const current = Number(weight);
      const previous = Number(previousWeight);
      if (!Number.isFinite(current) || !Number.isFinite(previous)) return null;

      const pounds = Number(((current - previous) * 2.204622).toFixed(1));
      return `${pounds > 0 ? '+' : ''}${pounds.toFixed(1)} lbs`;
    };

    const {
      goal,
      check_in_type,
      report_date,
      last_progress_summary,
      last_progress_value,
      weight,
      custom_calories_edit,
      near_period,
      check_in_vacation_mode_info
    } = data;

    const colorKey = {
      "full": "#4cb050",
      "partial": "#f4b300",
      "none": "#dc544a",
      "excess": (goal === "FAT LOSS") ? "#4cb050" : "#dc544a",
      "menstrual": "#181818",
      "sucess": "#4cb050",
      "inside": "#4cb050",
      "outside-below": "#dc544a",
      "outside-above": "#dc544a",
      "improving-below": "#f4b300",
      "improving-above": "#f4b300",
    };

    const weightChange = formatWeightChange(weight, data.previous_weight);
    const lastCheckinDate = (
      <>
        {moment.utc(report_date).format('MMM D, YYYY')}
        {check_in_type !== 12 && weightChange !== null && (
          <strong> · {weightChange}</strong>
        )}
      </>
    );

    if (check_in_type === 1) {
      // Non compliaant
      return (
        <LastCheckinCell>
          <DarkTooltip
            arrow
            title={
              <TipContent>
                <p>Out of range of target macros.</p>
              </TipContent>
            }
          >
            <LastCheckinContainer>
              <Bar>
                <div></div>
              </Bar>
              <p>Missed macros</p>
            </LastCheckinContainer>
          </DarkTooltip>
          <LastCheckinDate>
            {lastCheckinDate}
          </LastCheckinDate>
        </LastCheckinCell>
      );
    } else if (
      check_in_type === 3 ||
      check_in_type === 4 ||
      check_in_type === 5 ||
      check_in_type === 6 ||
      check_in_type === 7 ||
      check_in_type === 8 ||
      check_in_type === 9
    ) {
      const daysSinceCheckin = getDaysSinceWeighIn(report_date);
      let dayString;

      if (daysSinceCheckin === 0) {
        dayString = "today";
      } else if (daysSinceCheckin === 1) {
        dayString = "yesterday";
      } else {
        dayString = `${daysSinceCheckin} days ago`;
      }

      // Handle grey pill display
      let checkinKey = {
        "3": "Pending: New start",
        "4": "Pending: New user",
        "5": `Left ${(check_in_vacation_mode_info ? check_in_vacation_mode_info?.practice_mode ? "practice" : "pause" : 'vacation')} mode ${dayString}`,
        "6": "Activity level changed",
        "7": "Goal changed",
        "8": "Calories changed",
        "9": "Check-in edited",
      };

      let toolTextMap = "This is why calories changed, prompting a new starting weight to be collected and the next full check-in to be pushed back."
      if(check_in_type === 4) {
        toolTextMap = "No data to show since the client has not yet completed their first check-in on the system."
      } else if (check_in_type === 5) {
        toolTextMap = "Returning from pause or practice mode means the client has started a new check-in cycle and resumed tracking food."
      }

      // Handle calorie change text
      if (check_in_type === 8) {
        if (custom_calories_edit === 3) {
          checkinKey["8"] = 'Calories restored'
        } else {
          checkinKey["8"] = 'Calories edited'
        }
      }

      return (
        <DarkTooltip
          arrow
          title={
            <TipContent>
              <p>{toolTextMap}</p>
            </TipContent>
          }
        >
          <LastCheckinCell>
            <LastCheckinPill>
              <p>{checkinKey[check_in_type]}</p>
            </LastCheckinPill>
            <LastCheckinDate>
              {lastCheckinDate}
            </LastCheckinDate>
          </LastCheckinCell>
        </DarkTooltip>
      );
      
    } else if (check_in_type === 10 || check_in_type === 11) {
      // Handle reset
      const daysSinceCheckin = getDaysSinceWeighIn(report_date);
      let dayString;

      if (daysSinceCheckin === 0) {
        dayString = "today";
      } else if (daysSinceCheckin === 1) {
        dayString = "yesterday";
      } else {
        dayString = `${daysSinceCheckin} days ago`;
      }

      return (
        <DarkTooltip
          arrow
          title={
            <TipContent>
              <p>This is why calories changed, prompting a new starting weight to be collected and the next full check-in to be pushed back.</p>
            </TipContent>
          }
        >
          <LastCheckinCell>
            <LastCheckinPill>
              <p>Reset {dayString}</p>
            </LastCheckinPill>
            <LastCheckinDate>
              {lastCheckinDate}
            </LastCheckinDate>
          </LastCheckinCell>
        </DarkTooltip>
      );
    } else if (check_in_type === 12) {
      return (
        <LastCheckinCell>
          <LastCheckinContainer>
            <p>{(check_in_vacation_mode_info ? check_in_vacation_mode_info?.practice_mode ? "Practice mode" : "Goal paused" : 'vacation')} mode{weightChange !== null ? `: ${weightChange}` : ''}</p>
          </LastCheckinContainer>
          <LastCheckinDate>
            {lastCheckinDate}
          </LastCheckinDate>
        </LastCheckinCell>
      );
    } else if (last_progress_summary === "menstrual") {
      // Menstrual
      return (
        <LastCheckinCell>
          <LastCheckinPill>
            <span>Menstrual</span>
          </LastCheckinPill>
          <LastCheckinDate>
            {lastCheckinDate}
          </LastCheckinDate>
        </LastCheckinCell>
      );
    } else if (last_progress_summary === "none") {
      let tooltipTextKey = {
        "MUSCLE GAIN": "No weight was gained.",
        "FAT LOSS": "No weight was lost.",
      };
      
      // No Progress
      return (
        <DarkTooltip
          arrow
          title={
            <TipContent>
              <p>{tooltipTextKey[goal]}</p>
            </TipContent>
          }
        >
          <LastCheckinCell>
            <LastCheckinContainer>
              <Bar color={colorKey[last_progress_summary]} height={100}>
                <div></div>
              </Bar>
              {" "}
              <p>{Math.round(Number(last_progress_value * 100))}% of goal met</p>
            </LastCheckinContainer>
            <LastCheckinDate>
              {lastCheckinDate}
            </LastCheckinDate>
          </LastCheckinCell>
        </DarkTooltip>
      );
    } else if (goal === "FAT LOSS") {
      let tooltipFatlossText
      let barColor = colorKey[last_progress_summary]
      let barHeight = Number(last_progress_value * 100)

      if (Number(last_progress_value * 100) === 100) {
        tooltipFatlossText = 'Met weight loss goal.'
      } else if (Number(last_progress_value * 100) === 0 && near_period === 1) {
        tooltipFatlossText = 'No weight was lost, but period was affecting weight.'
        barColor = '#e129a3'
        barHeight = 100
      } else if (Number(last_progress_value * 100) === 0) {
        tooltipFatlossText = 'No weight was lost.'
      } else {
        tooltipFatlossText = 'Partially met weight loss goal.'
      }

      return (
        <DarkTooltip
          arrow
          title={
            <TipContent>
              <p>{tooltipFatlossText}</p>
            </TipContent>
          }
        >
          <LastCheckinCell>
            <LastCheckinContainer>
              <Bar color={barColor} height={barHeight}>
                <div></div>
              </Bar>
              {" "}
              <p>{Math.round(Number(last_progress_value * 100))}% of goal met</p>
            </LastCheckinContainer>
            <LastCheckinDate>
              {lastCheckinDate}
            </LastCheckinDate>
          </LastCheckinCell>
        </DarkTooltip>
      );
    } else if (goal === "MUSCLE GAIN") {
      let tooltipMuscleText
      let barColor = colorKey[last_progress_summary]
      let barHeight = Number(last_progress_value * 100)

      if (last_progress_summary === 'excess') {
        tooltipMuscleText = 'Too much weight was gained.'
      } else if (Number(last_progress_value * 100) === 100) {
        tooltipMuscleText = 'Met muscle gain goal.'
      } else if (Number(last_progress_value * 100) === 0 && near_period === 1) {
        tooltipMuscleText = 'Too much weight was gained, but period was affecting weight.'
        barColor = '#e129a3'
        barHeight = 100
      } else if (Number(last_progress_value * 100) === 0) {
        tooltipMuscleText = 'No weight was gained.'
      } else {
        tooltipMuscleText = 'Partially met muscle gain goal.'
      }

      return (
        <DarkTooltip
          arrow
          title={
            <TipContent>
              <p>{tooltipMuscleText}</p>
            </TipContent>
          }
        >
          <LastCheckinCell>
            <LastCheckinContainer>
              <Bar color={barColor} height={barHeight}>
                <div></div>
              </Bar>
              {" "}
              {last_progress_summary === "excess" ? 
                <p>Excess gain</p>
                : 
                <p>{Math.round(Number(last_progress_value * 100))}%  of goal met</p>
              }
            </LastCheckinContainer>
            <LastCheckinDate>
              {lastCheckinDate}
            </LastCheckinDate>
          </LastCheckinCell>
        </DarkTooltip>
        
      );
    } else if (goal === "REVERSE DIETING") {
      let tipText = "Stayed within weight gain limit"
      let barColor = colorKey[last_progress_summary]
      
      if (last_progress_summary === "excess" && near_period === 1) {
        tipText = "Exceeded weight gain limit, but period was affecting weight"
        barColor = '#e129a3'
      } else if (last_progress_summary === "excess") {
        tipText = "Exceeded weight gain limit."
      }
      
      return (
        <LastCheckinCell>
          <LastCheckinContainer>
            <Bar color={barColor} height={100}>
              <div></div>
            </Bar>
            {" "}
            <DarkTooltip
              arrow
              title={
                <TipContent>
                  <p>{tipText}</p>
                </TipContent>
              }
            >
              {last_progress_summary === "excess" ? 
                <p>Excess gain</p>
                : 
                <span>{last_progress_summary === "excess" ? "Excess gain" : last_progress_summary}</span>
              }
            </DarkTooltip>
          </LastCheckinContainer>
          <LastCheckinDate>
            {lastCheckinDate}
          </LastCheckinDate>
        </LastCheckinCell>
      );
    } else if (goal === "MAINTENANCE") {
      const textKey = {
        "inside": "in range",
        "outside-below": "under range",
        "outside-above": "over range",
        "improving-below": "under range",
        "improving-above": "over range",
      };

      const toolTextKey = {
        "inside": "Weighed in within maintenance range.",
        "outside-below": "Weighed in above range, but trending back down.",
        "outside-above": "Weighed in below range, but trending back up.",
        "improving-below": "Weighed in above maintenance range.",
        "improving-above": "Weighed in below maintenance range.",
      };
  
      return (
        <DarkTooltip
          arrow
          title={
            <TipContent>
              <p>{toolTextKey[last_progress_summary]}</p>
            </TipContent>
          }
        >
          <LastCheckinCell>
            <LastCheckinContainer>
              <Bar color={colorKey[last_progress_summary]} height={100}>
                <div></div>
              </Bar>
              {" "}
              <span style={{position: 'relative', textTransform: 'none'}}>
                {Math.round(Number(weight * 2.204622))} lbs: {textKey[last_progress_summary]}
                {(last_progress_summary === "improving-below" || last_progress_summary === "improving-above") && <ImprovingText>(improving)</ImprovingText>}
              </span>
            </LastCheckinContainer>
            <LastCheckinDate>
              {lastCheckinDate}
            </LastCheckinDate>
          </LastCheckinCell>
        </DarkTooltip>
      );
    } else {
      return (
        <LastCheckinCell>
          <LastCheckinContainer>
            <p>------</p>
          </LastCheckinContainer>
          <LastCheckinDate>
            {lastCheckinDate}
          </LastCheckinDate>
        </LastCheckinCell>
      );
    }
  };

  const renderCurrentCheckinData = (data, currentCheckinStatus) => {
    const { daysSinceCheckinDate } = data;

    let status = currentCheckinStatus
    const log_weekly_body_metrics = data.vacation_mode_info?.log_weekly_body_metrics
    if (data.vacation_mode_info && log_weekly_body_metrics) {
      if(daysSinceCheckinDate > 0) {
        status = "Late"
      } else if (daysSinceCheckinDate === 0) {
        status = "Today"
      } else {
        status = "Pending"
      }
    } else if (data.vacation_mode_info && !data.vacation_mode_info?.practice_mode && !log_weekly_body_metrics) {
      status = "Goal paused"
    } else if (data.vacation_mode_info && data.vacation_mode_info?.practice_mode && !log_weekly_body_metrics) {
      status = "Practice mode"
    }

    const colorMap = {
      "Pending": "#f4b300",
      "Today": "#4cb050",
      "Late": "#dc544a",
      // "On vacation": "#5e43c2",
      "Practice mode": "#000000",
      "Goal paused": "#1cb09c"
    };

    const textMap = {
      "Pending": `${Math.abs(daysSinceCheckinDate)} ${Math.abs(daysSinceCheckinDate) === 1 ? 'day' : 'days'} until check-in`,
      "Today": "Checked in earlier today",
      // "On vacation": "Client is on vacation",
      "Practice mode": "Client is in practice mode",
      "Goal paused": "Client is in pause your goal mode"
    }

    if (status === 'Late') {
      return (
        <DarkTooltip
          arrow
          title={
            <TipContent>
              <p>Client is late for their current check-in.</p>
            </TipContent>
          }
        >
          <DataCell bold color="#dc544a">
            {daysSinceCheckinDate} {daysSinceCheckinDate > 1 ? 'days' : 'day'} late
          </DataCell>
        </DarkTooltip>
      );
    } else {
      return (
        <DarkTooltip
          arrow
          title={
            <TipContent>
              <p>{textMap[status]}</p>
            </TipContent>
          }
        >
          <DataCell bold color={colorMap[status]}>
            {status === 'Pending' ? textMap.Pending : status}
          </DataCell>
        </DarkTooltip>
      )
    }
  };

  const renderSortArrows = (isSorting, reverse) => {
    return (
      <div style={{display: 'inline-block', marginLeft: '8px'}}>
        <ArrowsGroup>
          <ArrowUp fill={(isSorting && reverse) ? '#FFFFFF' : '#999999'} />
          <div style={{height: '3px'}}></div>
          <ArrowDown fill={(isSorting && !reverse) ? '#FFFFFF' : '#999999'}/>
        </ArrowsGroup>
      </div>
    )
  }

  const handleSort = (type) => {
    if (type !== sortType.type) {
      setSortType({type: type, reverse: false})
    } else {
      setSortType({type: type, reverse: !sortType.reverse})
    }
  }

  const handleSelect = (user_id) => {
    let selection = [...selectedUsers]

    if(selection.includes(user_id)) {
      _.remove(selection, (id) => id === user_id);
    } else {
      selection.push(user_id)
    }
    setSelectedUsers(selection)
  }

  const handleSelectAll = () => {
    const allUsers = []
    accounts.forEach((entry) => {
      if (entry.trainer_permission === 1 && entry.trainer_permission_edit === 1 && entry.user_id) {
        allUsers.push(entry.user_id)
      }
    })

    if (selectedUsers.length === allUsers.length) {
      setSelectedUsers([])
    } else {
      setSelectedUsers(allUsers)
    }
  }

  const getSelectAllChecked = () => {
    const allUsers = []
    accounts.forEach((entry) => {
      if (entry.trainer_permission === 1 && entry.trainer_permission_edit === 1 && entry.user_id) {
        allUsers.push(entry.user_id)
      }
    })
    return selectedUsers.length === allUsers.length
  }
  
  const submitBulkEdit = (selectedDay) => {
    const data = {
      local_today: todayString(),
      check_in_day: !selectedDay ? null : hostDateToString(selectedDay),
      user_ids: selectedUsers
    }

    bulkEditCheckinDay(user.id, data).then((res) => {
      openSnackbar('Check-in days have been updated.', false)
      loadProfile(user.id).then((res) => {
        if (res.data.profile.active === 1) {
          updateUser(res.data.profile)
        }
        setShowBulkModal(false)
      }).catch((err) => {
        console.log(err)
      })
    }).catch((err) => {
      console.log(err) 
      openSnackbar('There was an error editing check-in days.', true)
    })
  }

  const submitBulkVacation = (vacationData) => {
    const data = {
      local_today: todayString(),
      vacation_mode: vacationData.vacation_mode,
      vacation_mode_info: vacationData.vacation_mode_info,
      user_ids: selectedUsers
    }

    batchSetVacationMode(user.id, data).then((res) => {
      if (res.data.success) {
        const modeText = vacationData.vacation_mode === 0 ? 'Pause/practice mode turned off' : 
          vacationData.vacation_mode_info.practice_mode ? 'Practice mode enabled' : 'Pause your goal enabled';
        openSnackbar(`${modeText} for selected clients.`, false)
        loadProfile(user.id).then((res) => {
          if (res.data.profile.active === 1) {
            updateUser(res.data.profile)
          }
          setShowVacationModal(false)
        }).catch((err) => {
          console.log(err)
        })
      } else {
        openSnackbar(res.data.error || 'There was an error updating client settings.', true)
      }
    }).catch((err) => {
      console.log(err) 
      openSnackbar('There was an error updating client settings.', true)
    })
  }

  let accounts =_.cloneDeep(user.accounts);

  accounts.forEach((entry, index) => {
    //Tracking Status
    const { untracked_day_indices, report_date } = entry;
    const threshold_untracked_day_index = untracked_day_indices.length < attentionSettings.missedtracking ? null : untracked_day_indices[attentionSettings.missedtracking - 1];
    const daysSinceCheckin = getDaysSinceWeighIn(report_date);
    
    if (entry.vacation_mode > 0 && !entry.vacation_mode_info?.practice_mode) {
      accounts[index].trackingStatus = MISSED_TRACKING_LABELS[attentionSettings.missedtracking][3][0]
    } else if (threshold_untracked_day_index === null || threshold_untracked_day_index > daysSinceCheckin) {
      accounts[index].trackingStatus = MISSED_TRACKING_LABELS[attentionSettings.missedtracking][1][0]
    } else if (threshold_untracked_day_index === daysSinceCheckin) {
      accounts[index].trackingStatus = MISSED_TRACKING_LABELS[attentionSettings.missedtracking][0][0]
    } else if (threshold_untracked_day_index < daysSinceCheckin) {
      accounts[index].trackingStatus = MISSED_TRACKING_LABELS[attentionSettings.missedtracking][2][0]
    }

    const lastWeighInDateTemp = new Date(entry.report_date)
    const lastWeighInDate = new Date(lastWeighInDateTemp.getUTCFullYear(), lastWeighInDateTemp.getUTCMonth(), lastWeighInDateTemp.getUTCDate())
    let userCheckinDate = hostDateToString(lastWeighInDate)
    userCheckinDate = dateStringAddDays(userCheckinDate, 7)
    const lastWeighInDatePlus5Days = new Date(lastWeighInDate.getFullYear(), lastWeighInDate.getMonth(), lastWeighInDate.getDate() + 5)
    const nextPossibleWeighInDate = new Date(lastWeighInDatePlus5Days.valueOf())
    let desiredDayOfWeek = null

    if (entry.check_in_date) {
      const checkInDateTemp = new Date(entry.check_in_date);
      const checkInDate = new Date(
        checkInDateTemp.getUTCFullYear(),
        checkInDateTemp.getUTCMonth(),
        checkInDateTemp.getUTCDate()
      );
      desiredDayOfWeek = checkInDate.getDay()
      let dayOffset = desiredDayOfWeek - nextPossibleWeighInDate.getDay()
      if(dayOffset < 0) {
        dayOffset += 7
      }
      const desiredNextWeighInDate = new Date(nextPossibleWeighInDate.getFullYear(), nextPossibleWeighInDate.getMonth(), nextPossibleWeighInDate.getDate() + dayOffset)
      userCheckinDate = hostDateToString(desiredNextWeighInDate);
    }
    
    const daysSinceCheckinDate = getDaysSinceWeighIn(userCheckinDate);
    accounts[index].daysSinceCheckinDate = daysSinceCheckinDate

    //Current Check-in Status
    if (entry.vacation_mode > 0) {
      accounts[index].currentCheckinStatus = "Goal paused"
    } else if (daysSinceCheckin === 0) {
      accounts[index].currentCheckinStatus = "Today"
    } else if (daysSinceCheckinDate > 0) {
      accounts[index].currentCheckinStatus = "Late"
    } else {
      accounts[index].currentCheckinStatus = "Pending"
    }
  })

  accounts.sort((a, b) => {
    if (sortType.type === 'currentCheckinStatus') {
      const AdaysSinceCheckin = getDaysSinceWeighIn(a.report_date);
      const BdaysSinceCheckin = getDaysSinceWeighIn(b.report_date);

      if(AdaysSinceCheckin < BdaysSinceCheckin ) { return -1; }
      if(AdaysSinceCheckin > BdaysSinceCheckin ) { return 1; }
      return 0;
    } else {
      const aValue = a[sortType.type] ?? '';
      const bValue = b[sortType.type] ?? '';
      return aValue.localeCompare(bValue);
    }
  })

  if (sortType.reverse) {
    accounts.reverse();
  }

  return (
    <Container>
      <TitleContainer>
        <TableTitle>
          Client overview
          <BulkEdit
            highlight={showSelect}
            onClick={() => {setShowSelect(!showSelect); setSelectedUsers([]);}}
          >
            Bulk Edit
          </BulkEdit>
          {showSelect &&
            <>
              <BulkAction onClick={() => selectedUsers.length === 0 ? openSnackbar('No clients selected.', true) : setShowBulkModal(true)}>Edit check-in day</BulkAction>
              <BulkAction onClick={() => selectedUsers.length === 0 ? openSnackbar('No clients selected.', true) : setShowVacationModal(true)}>Edit pause/practice mode</BulkAction>
            </>
          }
          <ShowGroupFilter
            highlight={props.showGroupFilter}
            onClick={() => props.setShowGroupFilter(!props.showGroupFilter)}
          >
            {props.showGroupFilter ? 'Hide' : 'Show'} Group Filter
          </ShowGroupFilter>
        </TableTitle>
        {individualDaysForThisPeriod ? (
          <Legend>
            <span>Key: </span>
            <LegendKeys>
              <div>
                <Dot /> <p>Nothing logged</p>
              </div>
              <div>
                <Dot color="#f4b300" /> <p>Logged but out of range</p>
              </div>
              <div>
                <Dot color="#4cb050" /> <p>Logged and in range</p>
              </div>
              <div>
                <MenstrualKey /> <p>Menstrual cycle</p>
              </div>
              <div>
                <VacationIcon /> <p>Vacation</p>
              </div>
              <div>
                <PauseIcon /> <p>Goal paused</p>
              </div>
            </LegendKeys>
          </Legend>
        ) : (
          <Legend>
            <span>Key: </span>
            <LegendKeys>
              <div>
                <SmallMacroCircle color="#31bfff" /> <p>Under range</p>
              </div>
              <div>
                <SmallMacroCircle color="#00ee46" /> <p>In range</p>
              </div>
              <div>
                <SmallMacroCircle color="#ed28a5" /> <p>Over range</p>
              </div>
              <div>
                <MenstrualKey /> <p>Menstrual cycle</p>
              </div>
            </LegendKeys>
          </Legend>
        )}
      </TitleContainer>
      <TableContainer>
        <Table>
          <TableHead>
            <TableHeadRow>
              {showSelect &&
                <HeadCell>
                  <WhiteCheckbox
                    style={{color: '#FFF'}}
                    checked={getSelectAllChecked()}
                    onChange={handleSelectAll}
                    inputProps={{ "aria-label": "checkbox" }}
                  />
                </HeadCell>
              }
              <HeadCell bigWidth onClick={() => handleSort('name')}>
                <div style={{display: 'flex', alignItems: 'center', cursor: 'pointer'}}>
                  <p>Name</p> 
                  {renderSortArrows((sortType.type === 'name'), sortType.reverse)}
                </div>
              </HeadCell>
              <HeadCell>
                <div style={{display: 'flex', alignItems: 'center'}}>
                  <DarkTooltip
                    enterDelay={500}
                    arrow
                    placement="top"
                    title={individualDaysForThisPeriod ? (
                      <TipContent>
                        <p>Each circle represents a day of tracking since the last check-in:</p>
                        <div style={{height: '8px'}}></div>
                        <p style={{display: 'flex', alignItems: 'center'}}><Dot borderColor="1px solid #FFF" style={{marginRight: '8px'}} /> No food was logged</p>
                        <p style={{display: 'flex', alignItems: 'center'}}><Dot color="#f4b300" style={{marginRight: '8px'}} /> Food was logged but macros were missed</p>
                        <p style={{display: 'flex', alignItems: 'center'}}><Dot color="#4cb050" style={{marginRight: '8px'}} /> Food was logged and macros were hit</p>
                        <p style={{display: 'flex', alignItems: 'center'}}><PauseIcon style={{width: '10px', marginRight: '8px'}} /> Goal was paused </p>
                      </TipContent>
                    ) : (
                      <TipContent>
                        <p>Each circle represents one of three macronutrients (protein, carbs, fat):</p>
                        <div style={{height: '8px'}}></div>
                        <p style={{display: 'flex', alignItems: 'center'}}><SmallMacroCircle color="#31bfff" style={{marginRight: '8px'}} /> Under range</p>
                        <p style={{display: 'flex', alignItems: 'center'}}><SmallMacroCircle color="#00ee46" style={{marginRight: '8px'}} /> In range</p>
                        <p style={{display: 'flex', alignItems: 'center'}}><SmallMacroCircle color="#ed28a5" style={{marginRight: '8px'}} /> Over range</p>
                      </TipContent>
                    )}
                  >
                    <p style={{cursor: 'pointer'}} onClick={() => toggleThisPeriod(1 - individualDaysForThisPeriod)}>This Period <span ><ToggleLeft fill={individualDaysForThisPeriod ? '#FFFFFF' : '#999999'} /> <ToggleRight fill={individualDaysForThisPeriod ? '#999999' : '#FFFFFF'} /></span></p>
                  </DarkTooltip>
                </div>
              </HeadCell>
              <HeadCell onClick={() => handleSort('trackingStatus')}>
                <div style={{display: 'flex', alignItems: 'center', cursor: 'pointer'}}>
                  <DarkTooltip
                    enterDelay={500}
                    arrow
                    placement="top"
                    title={
                      <TipContent>
                        <p>This shows how consistently food is being logged during this check-in period:</p>
                        <div style={{height: '8px'}}></div>
                        <li><span style={{color: '#4cb050'}}>{MISSED_TRACKING_LABELS[attentionSettings.missedtracking][1][0]}</span> =  {MISSED_TRACKING_LABELS[attentionSettings.missedtracking][1][1]}</li>
                        <li><span style={{color: '#f4b300'}}>{MISSED_TRACKING_LABELS[attentionSettings.missedtracking][0][0]}</span> =  {MISSED_TRACKING_LABELS[attentionSettings.missedtracking][0][1]}</li>
                        <li><span style={{color: '#dc544a'}}>{MISSED_TRACKING_LABELS[attentionSettings.missedtracking][2][0]}</span> =  {MISSED_TRACKING_LABELS[attentionSettings.missedtracking][2][1]}</li>
                        <li><span style={{color: '#1cb09c'}}>{MISSED_TRACKING_LABELS[attentionSettings.missedtracking][3][0]}</span> =  {MISSED_TRACKING_LABELS[attentionSettings.missedtracking][3][1]}</li>
                      </TipContent>
                    }
                  >
                    <p>Tracking</p> 
                  </DarkTooltip>
                  {renderSortArrows((sortType.type === 'trackingStatus'), sortType.reverse)}
                </div>
              </HeadCell>
              <HeadCell bigWidth onClick={() => handleSort('goal')}>
                <div style={{display: 'flex', alignItems: 'center', cursor: 'pointer'}}>
                <DarkTooltip
                    arrow
                    placement="top"
                    title={
                      <TipContent>
                        <p>This shows what goal each client is on right now.</p>
                      </TipContent>
                    }
                  >
                    <p>Goal</p> 
                  </DarkTooltip>
                  {renderSortArrows((sortType.type === 'goal'), sortType.reverse)}
                </div>
              </HeadCell>

              <HeadCell bigWidth>
                <div style={{display: 'flex', alignItems: 'center'}}>
                  <DarkTooltip DarkTooltip
                    arrow
                    placement="top"
                    title={
                      <TipContent>
                        <p>This shows the results of the last full check-in. If a major setting was changed that affected calories after the last check-in day, that is shown instead.</p>
                      </TipContent>
                    }
                  >
                    <p>Last check-in</p>
                  </DarkTooltip>
                </div>
              </HeadCell>
              <HeadCell bigWidth onClick={() => handleSort('currentCheckinStatus')}>
                <div style={{display: 'flex', alignItems: 'center', cursor: 'pointer'}}>
                  <DarkTooltip
                    arrow
                    placement="top"
                    title={
                      <TipContent>
                        <p>This shows where the client is at in their current check-in period:</p>
                        <div style={{height: '8px'}}></div>
                        <li><span style={{color: '#4cb050'}}>Today</span> = Checked in earlier today</li>
                        <li><span style={{color: '#f4b300'}}>Days until check-in</span> = Time remaining until the next check-in</li>
                        <li><span style={{color: '#dc544a'}}>Late</span> = 8+ days into the check-in period</li>
                        {/* <li><span style={{color: '#5e43c2'}}>On vacation</span> = Client is on vacation</li> */}
                        <li><span style={{color: '#1cb09c'}}>Practice mode</span> = Client is on practice mode</li>
                        <li><span style={{color: '#FFFFFF'}}>Goal paused</span> = Client is on pause your goal mode</li>
                      </TipContent>
                    }
                  >
                    <p>Current check-in</p> 
                  </DarkTooltip>
                  {renderSortArrows((sortType.type === 'currentCheckinStatus'), sortType.reverse)}
                </div>
              </HeadCell>
              <HeadCell style={{textAlign: 'center', width: '180px'}}>Actions</HeadCell>
            </TableHeadRow>
          </TableHead>
          <TableBody>
            {accounts.map((entry, index) => {
              const qualifying = (filterGroupID === 0 || entry.groups.includes(filterGroupID)) && (clientsTrainerID === '' || entry.trainers.includes(clientsTrainerID))
              const coachingPlan = getAccountCoachingPlan(entry)
              const hasCoachingPlan = hasCoachingPlanInfo(coachingPlan)
              const actualEndDateNeedsAttention = canAccessCoachingPlans && hasCoachingPlan && needsActualEndDateAttention(coachingPlan.actual_end_date)
              const actualEndDateStatusText = hasCoachingPlan ? getActualEndDateStatusText(coachingPlan.actual_end_date) : null
              if (entry.report_date) {
                const userID = entry.user_id
                const chatID = `${config.STREAMCHAT.userPrefix}${userID}`
                const noSurveyCheckin = !(entry.check_in_type === 1 || entry.check_in_type === 2 || entry.check_in_type === 12)
                const surveyIcon = hostDateToString(entry?.survey?.recent_survey_report_date) === hostDateToString(entry.report_date) ? <AssignmentCheckIcon style={{fill: '#4cb050'}}/> : noSurveyCheckin ? <AssignmentIcon style={{fill: '#444444'}}/> : <ErrorOutlineIcon style={{fill: '#dc544a'}}/>
                const hasRecentSurvey = hostDateToString(entry?.survey?.recent_survey_report_date) === hostDateToString(entry.report_date)
                const hideResponse = !entry?.survey?.assigned_survey_id ? true : false
                const recentSurveyResponseDate = entry?.survey?.recent_survey_created_at
                  ? moment.utc(entry.survey.recent_survey_created_at).format("MMM D")
                  : null

                if (
                  entry.trainer_permission &&
                  entry.claimed === 1 &&
                  qualifying
                ) {
                    return (
                      <TableBodyRow
                        key={entry.id}
                        className={canAccessCoachingPlans ? getCoachingPlanBarClass(entry) : ''}
                      >
                        {showSelect &&
                          <DataCell>
                            {(entry.trainer_permission === 1 && entry.trainer_permission_edit === 1) &&
                              <WhiteCheckbox
                                checked={selectedUsers.includes(userID)}
                                onChange={() => handleSelect(userID)}
                                inputProps={{ "aria-label": "checkbox" }}
                              />
                            }
                          </DataCell>
                        }
                        <NameCell nearPeriod={entry.near_period}>
                          <NameCellContent>
                            {actualEndDateNeedsAttention ? (
                              <CoachingAttentionText
                                onClick={() => openCoachingEndDateModal(entry, coachingPlan)}
                                type="button"
                              >
                                {actualEndDateStatusText}
                                <EditIcon />
                              </CoachingAttentionText>
                            ) : null}
                            <DarkTooltip
                              title={
                                <TipContent>
                                  <p>{entry.name}</p>
                                  {entry.near_period === 1 && <p style={{color: '#ffbbe8'}}>* Client’s weight is being affected by their menstrual cycle</p>}
                                </TipContent>
                              }
                              arrow
                            >
                              <span>
                                {entry.near_period === 1 && (
                                  <img src={RefreshIcon} alt="icon" />
                                )}{" "}
                                  {entry.name}
                              </span>
                            </DarkTooltip>
                          </NameCellContent>
                        </NameCell>
  
                        <DataCell>
                          {individualDaysForThisPeriod ? (
                            <ThisPeriodCellIndividual data={entry} />
                          ) : (
                            <ThisPeriodCellAverage data={entry} />
                          )}
                        </DataCell>
  
                        {renderTrackingData(entry.trackingStatus)}
                        {renderGoalData(entry)}
  
                        {renderLastCheckinData(entry)}
  
                        {renderCurrentCheckinData(entry, entry.currentCheckinStatus)}
                        <DataCell style={{width: '180px'}}>
                          <Row style={{justifyContent: 'center'}}>
                            <Action
                              hide={hideResponse}
                              disabled={!entry?.survey?.assigned_survey_id}
                              tipText={hasRecentSurvey ? 'Client has completed their check-in form' : noSurveyCheckin ? 'Client has entered a starting weight. No check-in form is available.' : 'Client has not completed their check-in form'}
                              icon={surveyIcon}
                              text={recentSurveyResponseDate ? `Response ${recentSurveyResponseDate}` : `Response`}
                              onClick={() => {
                                if (hasRecentSurvey || entry?.survey?.recent_survey_report_date) {
                                  setResponseUserId(entry?.user_id)
                                  setShowSurveyModal(true)
                                } else {
                                  openSnackbar("Client has not completed their check-in form yet", true);
                                }
                              }}
                            />
                            <Action
                              icon={<SearchIcon />}
                              text="Inspect"
                              onClick={() => {
                                props.history.push(
                                  "/dashboard/inspect/" + entry.id + "/overview"
                                );
                              }}
                            />
                            {!!user.messaging ?
                              (createdStreamUsers.includes(chatID) && !entry.linked_portal_id) ?
                                <Action
                                  hideOnClick
                                  icon={<Icon>message</Icon>}
                                  text="Chat"
                                  onClick={() => handleMessage(entry.user_id)}
                                />
                              :
                                <Action
                                  disabled
                                  tipText={entry.linked_portal_id ? `This user is a coach account for ${entry.linked_portal_name}.` : 'This user must sign in before messaging is available.'}
                                  icon={<Icon>message</Icon>}
                                  text="Chat"
                                  onClick={() => null}
                                />
                              :
                              null
                            }
                          </Row>
                        </DataCell>
                      </TableBodyRow>
                    );
                } else if (
                  !entry.trainer_permission &&
                  entry.claimed === 1 &&
                  qualifying
                ) {
                  return (
                    <TableBodyRow
                      key={entry.id}
                      className={canAccessCoachingPlans ? getCoachingPlanBarClass(entry) : ''}
                    >
                      {showSelect &&
                        <DataCell />
                      }
                      <NameCell nearPeriod={entry.near_period}>
                        <NameCellContent>
                            {actualEndDateNeedsAttention ? (
                            <CoachingAttentionText
                              onClick={() => openCoachingEndDateModal(entry, coachingPlan)}
                              type="button"
                            >
                              {actualEndDateStatusText}
                              <EditIcon />
                            </CoachingAttentionText>
                          ) : null}
                          <DarkTooltip 
                            title={
                              <TipContent>
                                <p>{entry.name}</p>
                              </TipContent>
                            }
                            arrow
                          >
                            <NameText>{entry.name}</NameText>
                          </DarkTooltip>
                        </NameCellContent>
                      </NameCell>
                      <DataCell colSpan="5">
                        <PermissionText>User has not allowed viewing permissions.</PermissionText>
                      </DataCell>
                      <DataCell style={{width: '180px'}} />
                    </TableBodyRow>
                  )
                }
              } else {
                if (
                  qualifying
                ) {
                  return (
                    <TableBodyRow
                      key={entry.id}
                      className={canAccessCoachingPlans ? getCoachingPlanBarClass(entry) : ''}
                    >
                      {showSelect &&
                        <DataCell />
                      }
                      <NameCell nearPeriod={entry.near_period}>
                        <NameCellContent>
                            {actualEndDateNeedsAttention ? (
                            <CoachingAttentionText
                              onClick={() => openCoachingEndDateModal(entry, coachingPlan)}
                              type="button"
                            >
                              {actualEndDateStatusText}
                              <EditIcon />
                            </CoachingAttentionText>
                          ) : null}
                          <DarkTooltip 
                            title={
                              <TipContent>
                                <p>{entry.name}</p>
                              </TipContent>
                            }
                            arrow
                          >
                            <NameText>{entry.name}</NameText>
                          </DarkTooltip>
                        </NameCellContent>
                      </NameCell>
                      <DataCell colSpan="5">
                        <PermissionText>{entry.trainer_permission === 0 ? 'User has not allowed viewing permissions' : 'User information will only appear after they have set up their profile, and enabled viewing permissions'}</PermissionText>
                      </DataCell>
                      <DataCell style={{width: '180px'}} />
                    </TableBodyRow>
                  )
                }
              }
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <SurveyModal
        open={showSurveyModal}
        onClose={() => setShowSurveyModal(false)}
        // data={surveyData}
        clientUserID={responseUserId}
      />
      <CoachingEndDateModal
        clientName={selectedCoachingAccount && selectedCoachingAccount.name}
        isLoading={isCoachingEndDateLoading}
        onClose={closeCoachingEndDateModal}
        onSelectDay={setSelectedCoachingDay}
        onSubmit={submitCoachingEndDate}
        open={!!selectedCoachingAccount}
        selectedDay={selectedCoachingDay}
      />
      <BulkEditCheckin
        open={showBulkModal}
        onClose={() => setShowBulkModal(false)}
        handleSubmit={submitBulkEdit}
      />
      <BulkEditVacation
        open={showVacationModal}
        onClose={() => setShowVacationModal(false)}
        handleSubmit={submitBulkVacation}
      />
    </Container>
  );
};

export default withRouter(AccountsTable);
